import React from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

export function itemRenderTable(current: any, type: any, originalElement: any) {
  if (type === "prev") {
    return (
      <span className="border-ant-prev-table font-size-10px">
        <LeftOutlined className="font-color-051923bf" style={{ display: "inline-flex", paddingRight: "2px" }} />
        Ant.
      </span>
    );
  }
  if (type === "next") {
    return (
      <span className="border-ant-prev-table font-size-10px">
        Sig.
        <RightOutlined className="font-color-051923bf" style={{ display: "inline-flex", paddingLeft: "2px" }} />
      </span>
    );
  }
  return originalElement;
}
